const parseTeams = (teams) =>
    teams.map((team) => ({
        id: team.id,
        ...team,
    }));

export default parseTeams;
